import { updateRegenerationTime } from "stores/slice/bogus/topology/const";

const topologiesConfig = {
  "/ents/:entId/orgs/:orgId/sites/:siteId/devices/regeneration.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/regeneration",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateRegenerationTime,
    mockSelector: "topology.regenerationMock",
  },
  "/orgs/:orgId/sites/:siteId/devices/regeneration.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/regeneration",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateRegenerationTime,
    mockSelector: "topology.regenerationMock",
  },
  "/ents/orgs/sites/topology.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/topology",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "topology",
  },
  "/orgs/sites/topology.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/topology",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "topology",
  },
}

export default topologiesConfig;